import type { FunctionComponent } from "react"

import { JOB_ADS_TITLE_ANCHOR_ID } from "@/modules/companies/client/components/JobAdsTitle/JobAdsTitle"
import { Pagination as JobAdsPagination } from "@/modules/jobAds/client/components/Pagination/Pagination"
import { useJobAdsFromAlgolia } from "@/modules/jobAds/client/hooks/useJobAdsFromAlgolia"

export const JobAdsPaginationWrapper: FunctionComponent = () => {
  const { dataJobAds, isLoadingJobAds, isErrorJobAds } = useJobAdsFromAlgolia()

  const onPaginate = (): void => {
    setTimeout(() => {
      document.getElementById(JOB_ADS_TITLE_ANCHOR_ID)?.scrollIntoView({ behavior: "smooth" })
    }, 100)
  }

  if (!dataJobAds || isLoadingJobAds || isErrorJobAds) return null

  return <JobAdsPagination totalSize={dataJobAds.totalSize} onPaginate={onPaginate} />
}
